import { endpoint, EndpointError } from '../endpoint';
import pubnubServer from 'utils/pubnub-server';

export type GetRoomInfoParams = {
  id: string;
};

export type GetRoomInfoResult = {
  data: NonNullable<Awaited<ReturnType<typeof pubnubServer.getRoomSystemInfo>>>['data']['custom'];
};
export type GetRoomInfoError = EndpointError;

export const getRoomInfoFromPubnub = endpoint<GetRoomInfoParams, GetRoomInfoResult, GetRoomInfoError>({
  method: 'GET',
  url: (params) => `/room/get-room-info/${params.id}`,
});
